export default {
	forms: {
		edit: {
			panel: {
				width: '70%'
			},
			config: {
				fields: {
					id: {
						config: {
							visible: false
						}
					},
					name: {}
				}
			}
		},
		list: {
			config: {
				fields: {
					id: {
						config: {
							visible: false
						}
					},
					name: {}
				}
			}
		},
		select: {
			panel: {
				height: '500px',
				width: '70%'
			},
			config: {
				fields: {
					id: {
						config: {
							visible: false
						}
					},
					name: {}
				}
			}
		}
	}
}